import { type FC } from 'react';
import { useToolNavigationDataProvider } from './ToolNavigationDataProvider';
import classes from '../styles/index.module.css';
import { urlToTestId } from '../utils';
import { useTranslationAPI } from '../../translations';
import RouteLink from '../../../components/RouteLink';
import { ToolNavigationSupportItem } from './ToolNavigationSupportItem';

export const ToolNavigationFooter: FC = () => {
	const navData = useToolNavigationDataProvider();
	const { translate } = useTranslationAPI();

	return (
		<div className={classes.footer}>
			{navData.supportNavigationItems.map((item) => (
				<ToolNavigationSupportItem
					key={item.url}
					url={item.url}
					title={translate(item.titleCode)}
					icon={item.icon}
					target='_blank'
					pageTypeId={item.pageTypeId}
					childNavigationItems={item.childNavigationItems}
				/>
			))}
			<ul className={classes.footerList}>
				<li className={classes.footerItem}>
					<button className={classes.footerYear}>©&nbsp;{new Date().getFullYear()}</button>
				</li>
				{navData.footerNavigationItems.map((item) => (
					<li
						key={item.url}
						className={classes.footerItem}
					>
						<RouteLink
							href={item.url}
							hasColor={false}
							dataTestId={urlToTestId(item.url)}
							useDirty
						>
							{translate(item.titleCode)}
						</RouteLink>
					</li>
				))}
			</ul>
		</div>
	);
};
